<template>
  <div class="mm_login">
    <div class="text-center" v-if="!getUser && (this.$mmconfig.allowUserLogin || this.$mmconfig.allowUserRegistration || this.$mmconfig.allowPasswordReset)">
      <v-btn
        color="info"
        dark
        @click="open()"
        id="mm-login-button"
        class="d-none d-sm-flex"
      >{{ $t('login.login') }}</v-btn>
      <v-dialog
        v-model="dialog"
        width="500"
      >
        <component
          v-bind:is="currentDialog"
          @close="close"
          @switchTab="switchTab"></component>
      </v-dialog>
    </div>
    <v-container
      v-if="getUser"
      fluid
      style="height: 300px"
    >
      <v-row justify="center">
        <v-menu
          bottom
          min-width="240px"
          rounded
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              x-large
              v-on="on"
              id="mm-login-avatar"
            >
              <v-avatar
                color="deep-purple lighten-1"
                size="32"
              >
                <span class="white--text">{{ getUser.nicename.charAt(0).toUpperCase() }}</span>
              </v-avatar>
            </v-btn>
          </template>
          <v-card>
            <v-list-item-content class="justify-center">
              <div class="mx-auto text-center">
                <v-avatar
                  color="deep-purple lighten-1"
                  size="62"
                >
                  <span class="white--text headline">{{ getUser.nicename.charAt(0).toUpperCase() }}</span>
                </v-avatar>
                <h3 class="mt-2 mx-2">{{ getUser.displayName }}</h3>
                <p class="caption mt-1">
                  {{ getUser.email }}
                </p>
                <v-divider class="my-3"></v-divider>
                <v-btn
                  depressed
                  outlined
                  text
                  @click="logout()"
                >
                  {{ $t('login.logout') }}
                </v-btn>
              </div>
            </v-list-item-content>
          </v-card>
        </v-menu>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Login from "./login/Login.vue";
  import Registration from "./login/Registration.vue";
  import ResetPassword from "./login/ResetPassword.vue";
  import {eventBus} from "../main.js";


  export default {
    name: 'Login',
    components: {
      Login,
      Registration,
      ResetPassword
    },
    data () {
      return {
        dialog: false,
        currentDialog: Login,
      }
    },
    created() {
      eventBus.$on('login', () => {
        this.open();
      }),
      eventBus.$on('logout', () => {
        this.logout();
      })
    },
    computed: {
      getUser: {
        get () {
          return this.$store.state.user
        }
      },
    },
    methods: {
      open() {
        // set default currentDialog tab corresponding to plugin settings
        // from less to more important: ResetPassword, Registration, Login
        if(this.$mmconfig.allowPasswordReset) {
          this.currentDialog = ResetPassword
        }
        if(this.$mmconfig.allowUserRegistration) {
          this.currentDialog = Registration
        }
        if(this.$mmconfig.allowUserLogin) {
          this.currentDialog = Login
        }
        // open dialog
        this.dialog = true
      },
      close() {
        // close dialog
        this.dialog = false
      },
      logout() {
        this.$store.dispatch('logout')
        this.$store.dispatch('message', { content: this.$i18n.t('login.logoutSuccess'), color: 'success' })
      },
      switchTab(val) {
        this.currentDialog = Login
        
        if(val === 'registration' && this.$mmconfig.allowUserRegistration) {
          this.currentDialog = Registration
        }
        if (val === 'resetPassword' && this.$mmconfig.allowPasswordReset) {
          this.currentDialog = ResetPassword
        }
      }
    }
  }
</script>
<style>
  #mm-login-button {
    position: absolute !important;
    right: 30px;
    top: 15px;
  }
  #mm-login-avatar {
    position: absolute !important;
    right: 19px;
    top: 4px;
  }
</style>